import { Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { HEADING, LINK } from './footerStyles';
import type { FooterLink } from './footerLinks';

export const FooterLinkItem = ({ link, onClick }: { link: FooterLink; onClick?: () => void }) => {
  const label = <FormattedMessage id={link.labelId} defaultMessage={link.defaultLabel} />;
  const sharedProps = {
    display: 'block',
    w: '100%',
    textAlign: 'start' as const,
    color: LINK,
    textStyle: 'bodySmallMedium',
    fontWeight: 400,
    textDecoration: 'none',
    _hover: { color: HEADING },
    transition: 'color 0.15s',
  };

  if (link.href) {
    return (
      <Text
        as='a'
        href={link.href}
        target={link.href.startsWith('mailto:') ? undefined : '_blank'}
        rel='noopener noreferrer'
        onClick={onClick}
        {...sharedProps}
      >
        {label}
      </Text>
    );
  }

  return (
    <Text as={Link} to={link.to} onClick={onClick} {...sharedProps}>
      {label}
    </Text>
  );
};
